import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import FixedProfitEditForm from './FixedProfitEditForm';
import { SettingsFormHeader } from '../../common/SettingsFormHeader';
import ENUMS from '../../../constants/enums';
import { themeColors } from '../../../constants/themes';
import CompetitionEditForm from './CompetitionEditForm';
import PenetrationEditForm from './PenetrationEditForm';
import RangedProfitEditForm from './RangedProfitEditForm';

const EditPopup = styled.div`
  border: 1px dashed ${themeColors.dirtyLightBlue};
  padding: 10px 15px;
  border-radius: 4px;
`;

@injectIntl
@observer
class EditStrategyPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    this.props.updateBreadcrumbs(
      {
        name: this.props.intl.formatMessage({ id: 'settingsModal.editPricing' }),
        handleClick: () => {},
      },
      false,
    );
  }

  renderEditForm = () => {
    const { PRICING_STRATEGIES } = ENUMS;
    const {
      pricingToEdit,
      sellersAccounts,
      selectedAccountCode,
      saveNewPricing,
      getStrategyDefaultValues,
      type,
      isUpdatingAllStore,
      setIsUpdatingAllStore
    } = this.props;

    switch (type) {
      case PRICING_STRATEGIES.FIXED_PRICE:
        return (
          <FixedProfitEditForm
            saveNewPricing={saveNewPricing}
            pricing={pricingToEdit}
            sellersAccounts={sellersAccounts}
            selectedAccountCode={selectedAccountCode}
            getStrategyDefaultValues={getStrategyDefaultValues}
            type={type}
            isUpdatingAllStore={isUpdatingAllStore}
            setIsUpdatingAllStore={setIsUpdatingAllStore}
          />
        );
      case PRICING_STRATEGIES.COMPETITION:
        return (
          <CompetitionEditForm
            saveNewPricing={saveNewPricing}
            pricing={pricingToEdit}
            sellersAccounts={sellersAccounts}
            selectedAccountCode={selectedAccountCode}
            getStrategyDefaultValues={getStrategyDefaultValues}
            type={type}
            isUpdatingAllStore={isUpdatingAllStore}
            setIsUpdatingAllStore={setIsUpdatingAllStore}
          />
        );
      case PRICING_STRATEGIES.PENETRATION:
        return (
          <PenetrationEditForm
            saveNewPricing={saveNewPricing}
            pricing={pricingToEdit}
            sellersAccounts={sellersAccounts}
            selectedAccountCode={selectedAccountCode}
            getStrategyDefaultValues={getStrategyDefaultValues}
            type={type}
            isUpdatingAllStore={isUpdatingAllStore}
            setIsUpdatingAllStore={setIsUpdatingAllStore}
          />
        );
      case 'rangedProfit':
        return (
          <RangedProfitEditForm
            saveNewPricing={saveNewPricing}
            pricing={pricingToEdit}
            sellersAccounts={sellersAccounts}
            selectedAccountCode={selectedAccountCode}
            getStrategyDefaultValues={getStrategyDefaultValues}
            type={type}
            isUpdatingAllStore={isUpdatingAllStore}
            setIsUpdatingAllStore={setIsUpdatingAllStore}
          />
        );
      default:
        return 'Unknown Pricing Strategy Id';
    }
  };

  render() {
    return (
      <EditPopup>
        <SettingsFormHeader
          id="pricing.editPricing"
          defaultMessage="EDIT PRICING"
          closeButton={this.props.closePopup}
          marginTop="0px"
          marginBottom="19px"
        />
        {this.renderEditForm()}
      </EditPopup>
    );
  }
}

EditStrategyPopup.propTypes = {
  intl: PropTypes.object,
  closePopup: PropTypes.func,
  saveNewPricing: PropTypes.func,
  pricingToEdit: PropTypes.object,
  sellersAccounts: PropTypes.array,
  selectedAccountCode: PropTypes.string,
  getStrategyDefaultValues: PropTypes.func,
  updateBreadcrumbs: PropTypes.func,
  type: PropTypes.string,
};

export default EditStrategyPopup;
